// TG GRACIAS A MI SEÑOR DIOS TG TG TG TG
// CartDisplay.js
import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from './ContextVars';
import translations from './translations';
import { useNavigate } from 'react-router-dom'; // #added 20/7/25 TG
import { parsePlanId } from './planHelpers'; // #added pegar link de plan 21/8/26 TG

const CartDisplay = () => {
    const {cart, setCart, totalAmount, totalAmountGTQ, language} = useContext(AppContext);
    const t = (key) => translations.CartDisplay[key]?.[language] || key;
    // const [totalUSD, setTotalUSD] = useState(0); // #deleted porque le pusimos el global totalAmount TG 20/7/25 TG TG TG
    // const [totalGTQ, setTotalGTQ] = useState(0);
//   const totalUSD = cart.reduce((sum, item) => sum + parseFloat(item.price || 0), 0);
//   const totalGTQ = cart.reduce((sum, item) => sum + parseFloat(item.pricegtq || 0), 0);
    const navigate = useNavigate();
    const [linkInput, setLinkInput] = useState(''); // #added 21/8/26 TG
    const [linkError, setLinkError] = useState(''); // #added 21/8/26 TG

 const handleRemove = (indexToRemove) => {
  const updatedCart = cart.filter((_, index) => index !== indexToRemove);
  setCart(updatedCart);
};

  const handleCheckout = () => {
    // alert('Proceeding to checkout!');
    // Add your real checkout logic here (e.g., navigate or payment trigger)
    navigate('/checkout');
  };

  // #added el usuario pega el link de un plan (o solo el número) y lo mandamos
  // a /add/:id, que es el mismo camino que usa la app de workouts. 21/8/26 TG
  const handleAddByLink = (e) => {
    e.preventDefault();
    const id = parsePlanId(linkInput);
    if (!id) {
      setLinkError(t('badLink'));
      return;
    }
    setLinkError('');
    setLinkInput('');
    navigate(`/add/${id}`);
  };

/*useEffect(() => {
    const tusd = cart.reduce((sum, item) => sum + parseFloat(item.price || 0), 0);
    const tgtq = cart.reduce((sum, item) => sum + parseFloat(item.pricegtq || 0), 0)
    setTotalUSD(tusd);
    setTotalGTQ(tgtq);

    }, [cart]);*/

  return (
    <div className="cart-container">
      <h2>{t('yourCart')}</h2>
      {cart.length === 0 ? (
        <div className="cart-empty">{t('empty')}</div>
      ) : (
        <>
          <ul className="cart-items">
          {cart.map((item, index) => (
  <div key={index} className="cart-item">
    <div className="cart-item-details">
      <span className="item-name">{item.name}</span>
      <span className="item-price">${parseFloat(item.price).toFixed(2)}</span>
      <span className="item-pricegtq">Q{parseFloat(item.pricegtq).toFixed(2)}</span>
    </div>
    <button className="remove-button" onClick={() => handleRemove(index)}>✖</button>
  </div>
))}
          </ul>
          <div className="cart-total">
            <strong>{t('total')}</strong> ${totalAmount.toFixed(2)} / Q{totalAmountGTQ.toFixed(2)}
          </div>
          <button className="checkout-button" onClick={handleCheckout}>{t('checkout')}</button>
        </>
      )}

      {/* #added pegar el link de un programa para agregarlo al carrito 21/8/26 TG */}
      <form onSubmit={handleAddByLink} className="cart-add-link">
        <label className="cart-add-link__label">{t('addByLink')}</label>
        <div className="cart-add-link__row">
          <input
            type="text"
            value={linkInput}
            onChange={(e) => { setLinkInput(e.target.value); setLinkError(''); }}
            placeholder={t('addByLinkPlaceholder')}
            className="cart-add-link__input"
          />
          <button type="submit" className="cart-add-link__button">{t('add')}</button>
        </div>
        {linkError && <div className="cart-add-link__error">{linkError}</div>}
      </form>
    </div>
  );
};

export default CartDisplay;
